<template>
  <el-dialog
    title="二维码"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="45%"
  >
    <div class="demo-image">
      <div class="block" v-for="image in imageList" :key="image">
        <el-image
          style="width: 200px; height: 200px"
          :src="image.url"
        ></el-image>
        <div class="demonstration">{{ image.id }}</div>
        <div class="demonstration">----------------------</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
////import { mapGetters } from "vuex";
export default {
  props: {
    imageIDs: {
      default: null
    }
  },
  data() {
    return {
      //sites: [{ name: "Runoob" }, { name: "Google" }, { name: "Taobao" }]
      imageList: []
    };
  },
  methods: {
    closeForm() {
      this.$emit("closeForm");
    }
  },

  computed: {},
  mounted() {
    this.imageList = this.imageIDs.map(ele => {
      return {
        id: ele,
        url: "/api/shared/wxacode?scene=a-" + ele
      };
    });
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
